const $win = $(window);
const $doc = $(document);
const $body = $('body');
const $sidebar = $('.sidebar');
const $activeQuestion = $('.list-questions li.active');
const $dropdownLanguageOuter = $('.bootstrap-select');
const $popoverLink = $('[data-bs-toggle="popover"]');
const $inputField = $('input');
const $searchFieldOptions = $('.search--options .search__field');
const mobileBreakpoint = 768;
let windowHeight = $win.height();
let windowWidth = $win.width();

/**
 * Tooltip position.
 */

function tooltipPlacement() {

  $('.tooltip-alt').each(function () {
    const $tooltip = $(this);
    const $tooltipContent = $tooltip.find('.tooltip__content');
    const $tooltipContentHeight =  $tooltipContent.outerHeight();
    const $tooltipContentWidth =  $tooltipContent.outerWidth();
    const tooltipOffsetTop = $tooltip.offset().top;
    const tooltipOffsetLeft = $tooltip.offset().left;
    const tooltipOffsetRight = ($(window).width() - ($tooltip.offset().left + $tooltipContentWidth));
    const tooltipOffsetBottom = ($(window).height() - ($tooltip.offset().top + $tooltipContentHeight));

    if ($tooltipContentHeight + 20 >= tooltipOffsetTop || $tooltipContentWidth + 20 >= tooltipOffsetLeft) {
      $tooltip.addClass('bottom');
    } else {
      $tooltip.removeClass('bottom');
    }

    if (tooltipOffsetRight <= 20 || $tooltipContentWidth + 20 >= tooltipOffsetLeft) {
      $tooltip.addClass('top');
    } else {
      $tooltip.removeClass('top');
    }

    if ($tooltip.find('.tooltip-bottom').length) {
      $tooltip.removeClass('top')
      $tooltip.addClass('bottom')
    }
  })
}

$('.modal').on('shown.bs.modal', function () {
  tooltipPlacement();
})

$(window).on('resize load', function () {
  tooltipPlacement();
})


/**
 * Check table row
 */

let tableChecks = $('.js-table-check');

tableChecks.each(function () {
  $(this).on('change', function () {
    if (!$(this).is(':checked')) {
      $(this).closest('tr').removeClass('is-checked');
      return;
    }

    $(this).closest('tr').addClass('is-checked');
  });
});

/**
 * Pol dropdown functionality;
 */

if ($('.js-pol-dropdown-trigger').length) {
  $('.js-pol-dropdown-trigger').on('click', function(event) {
    event.preventDefault();

    $(this).closest('li').toggleClass('is-active').find('.pol__replies--dropdown').slideToggle(300)
  })
}


/**
 *  Initialize selectpicker with dropdown-select
 */

$('.selectpicker').selectpicker({
  dropupAuto: false,
});

$('.selectpickersearch').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
    if ($(this).find("option:checked").length > 0) {
      $(this).siblings('.dropdown-toggle').addClass('is-selected');
      $(this).parent().addClass('is-selected');
    } else {
      $(this).siblings('.dropdown-toggle').removeClass('is-selected');
      $(this).parent().removeClass('is-selected');
    }
});


/**
 *  Initialize each UI slider range
 */

const $rangeSlider = $('.slider-range');
const rangeSliderOptions = $rangeSlider.data('options');

if($rangeSlider.length) {
  $rangeSlider.each(function() {
    $rangeSlider.slider({
      range: rangeSliderOptions.range,
      min: rangeSliderOptions.min,
      max: rangeSliderOptions.max,
      value: rangeSliderOptions.value
    });
  })
}

/**
 *  Initialize bootstrap toast
 */

$('.toast').toast('show');

  // For a pie chart

  //Charts
function doAJAX(url, callback) {
  $.getJSON(url, function(response) {
    callback(response);
  });
}

function donutChart($container) {
  $container.each(function() {
    const $this = $(this);
    const source = $this.data('source');
    const colors = $this.data('colors');
    const name = $this.data('name');

    doAJAX(source, function(data) {
      $this.highcharts({
        chart: {
          type: 'solidgauge',
          height: 350,
          },
          colors: ['#EA4C8C', '#854DFF', '#BEBEBE'],
          licenses: {
            enabled: false
          },
          title: {
            text: null,
          },
          tooltip: {
            enabled: false
          },
          pane: {
            startAngle: 0,
            endAngle: 360,
            background: [{
              outerRadius: '112%',
              innerRadius: '88%',
              backgroundColor: '#BEBEBE',
              borderWidth: 24,
              borderColor: 'white'
            }]
          },
          yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: []
          },
          plotOptions: {
            solidgauge: {
              borderWidth: '20px',
              allowPointSelect: false,
              size: '100%',
              dataLabels: {
                enabled: false
              },
              linecap: 'round',
              stickyTracking: false
            }
          },
          legend: {
            useHTML: true,
            layout: 'vertical',
            symbolWidth: 0,
            floating: true,
            verticalAlign: 'top',
            labelFormatter: function() {
              return '<span class="legend-item"><small class="pill" style="background-color: '+ this.userOptions.borderColor +'"></small>' +  this.name + '</span>';
            }
          },
          series: [{
            showInLegend: true,
            name: '513 Not Started (19%)',
            borderColor: 'transparent',
            data: [{
              radius: '100%',
              innerRadius: '100%',
              y: 100
            }]
          }, {
            showInLegend: true,
            name: '750 Completed (25%)',
            borderColor: '#854DFF',
            color: '#854DFF',
            data: [{
              radius: '100%',
              innerRadius: '100%',
              y: 80
            }]
          }, {
            showInLegend: true,
            name: '1206 In Progress (46%)',
            borderColor: '#EA4C8C',
            data: [{
              radius: '100%',
              innerRadius: '100%',
              y: 65
            }]
          }]
      });

      $this.addClass('chart-drawn');
    });
  });
}

donutChart($('.donut'));

  /**
 *  Equalizie child and parent height
 */

function equalChildAndParentHeight() {
  const $parent = $('.js-height');
  const parentHeight = $('.js-height').outerHeight() + 'px';
  const $child = $parent.find('> div');

  $child.css('height', parentHeight);
}

/**
 *  Handle all events - click, mouseup and etc.
 */

function handleEvents() {
  /**
   *  Handle the mobile sidebar opening
   */

  if ( $( "#chapter_intro" ).length ) {
    $('.content').addClass('d-none');

    $('#chapter_intro').fadeOut(3000, function(event) {
      $('.content').removeClass('d-none');
    });
  }

  $('.btn-sidebar').on('click', function(event) {
    const $btn = $(this);

    $btn.parents('.sidebar').addClass('open');
    $body.addClass('fixed');

    event.preventDefault();
  });

  /**
   *  Handle the mobile sidebar closing
   */

  $('.sidebar .btn-back').on('click', function(event) {
    const $btn = $(this);

    $btn.parents('.sidebar').removeClass('open');
    $body.removeClass('fixed');

    event.preventDefault();
  });


  $(".sidebar").swipe( {
    swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
      if(direction == 'left'){
        $(this).removeClass('open');
        $body.removeClass('fixed');
      }
    }
  });

  /**
   *  Close the sidebar when click on body
   */

  $doc.mouseup(event => {
    const inSidebar = !$sidebar.is(event.target) && $sidebar.has(event.target).length === 0;

    if (inSidebar) {
      $sidebar.removeClass('open');
    }
  });

  /**
   *  Open the dropdown with suggestions when start typing
   */

  $searchFieldOptions.on('input', function(event) {
    const $field = $(this);

    if($field.val()) {
      $field.parents('.search--options').addClass('open');
    } else {
      $field.parents('.search--options').removeClass('open');
    }
  });

  /**
   *  Add class on input fields when typing
   */

  $inputField.on('input', function(event) {
    const $field = $(this);

    if($field.val()) {
      $field.addClass('active');
    } else {
      $field.removeClass('active');
    }
  });

  /**
   *  Initialize the popovers
   */

  $popoverLink.on('click', function(event) {
    const $currentPopupButton = $(this);
    const $currentPopup = $currentPopupButton.siblings();

    $currentPopup.toggleClass('show');

    event.preventDefault();
  });
}

/**
 *  Add the content of the active question for mobile in the bar
 */

function addActiveQuestionContent() {
  const $questions = $('.sidebar .sidebar__inner .list-questions li');
  const $activeQuestion = $('.sidebar .sidebar__inner .list-questions li.active');
  const $activeQuestionBar = $('.sidebar .sidebar__bar .list-questions li.active');

  const activeQuestionTitle = $activeQuestion.find('h6').text();
  const activeQuestionTime = $activeQuestion.find('small').text();
  const activeQuestionIndex = $activeQuestion.find('figure').text();

  const $activeQuestionTitleBar = $activeQuestionBar.find('h6');
  const $activeQuestionTimeBar = $activeQuestionBar.find('small');
  const $activeQuestionIndexBar = $activeQuestionBar.find('figure');

  const questionsLength = $questions.length;

  $activeQuestionTitleBar.html(activeQuestionTitle);
  $activeQuestionTimeBar.html(activeQuestionTime);
  $activeQuestionIndexBar.html(`<strong> ${activeQuestionIndex} </strong> / ${questionsLength}`);
}

/**
 *  Count all questions and set the data index of every question
 */

function countQuestions() {
  const $allQuestions = $('.sidebar .sidebar__inner .list-questions li');
  const allQuestionsLength = $('.sidebar .sidebar__inner .list-questions li').length - 1;
  const activeQuestionIndex = $('.sidebar .sidebar__inner .list-questions li.active').index() + 1;

  $allQuestions.each(function(){
    const $question = $(this);
    const currentQuestionIndex = $question.index() + 1;

    $question.attr('data-index', currentQuestionIndex);
    $question.find('figure').html(currentQuestionIndex)
  });
}


/**
 *  Add active class to the question in the bar for mobile
 */

function addActiveClassOfQuestion() {
  const $activeQuestion = $('.sidebar .sidebar__inner .list-questions li.active');
  const $questionBar = $('.sidebar .sidebar__bar .list-questions li');

  if($activeQuestion.length) {
    $questionBar.addClass('active');
  }
}

/**
 *  Handle the dropdown select changes
 */

function addLanguageDropdownClass() {
  const $dropdownLanguage = $('.selectpicker');

  $dropdownLanguage.on('show.bs.select', function () {
    const $dropdown = $(this);
    const $dropdownMenu = $dropdown.siblings('.dropdown-menu');
    const isAtTop = $dropdownMenu.attr('data-popper-placement') == 'top-start';
    const isAtBottom = $dropdownMenu.attr('data-popper-placement') == 'bottom-start';

    if(isAtTop) {
      $dropdownMenu.parent('.bootstrap-select').removeClass('bottom');
      $dropdownMenu.parent('.bootstrap-select').addClass('top');
    } else if(isAtBottom) {
      $dropdownMenu.parent('.bootstrap-select').removeClass('top');
      $dropdownMenu.parent('.bootstrap-select').addClass('bottom');
    }
  });
}

$win
  .on('load turbo:load', function() {
    handleEvents();
    addActiveClassOfQuestion();
    countQuestions();
    addActiveQuestionContent();
    $('.modal-show').modal('show');

    if($('.donut__tooltip-outer').length) {
      $('.donut__tooltip-outer').delay(1000).fadeIn()
    }
  })
  .on('load turbo:load orientationchange', function() {
    if($dropdownLanguageOuter) {
      addLanguageDropdownClass();
      // addDisabledDropdownClass();
    }
  })
  .on('load turbo:load resize orientationchange', function() {
    equalChildAndParentHeight();

    if(windowWidth < mobileBreakpoint) {
      $('.sidebar .sidebar__inner').css('height', windowHeight + 'px');
    }

    windowHeight = $win.height();
    windowWidth = $win.width();
  })
  .on('load turbo:load scroll', function() {
    $('.sections-home').each(function() {
      var $sectionFade = $(this);
      var sectionFadeO = $sectionFade.offset().top;

      if ($win.scrollTop() + $win.height() * 0.8 > sectionFadeO) {
        $sectionFade.addClass('section-in');

        if ( $sectionFade.find('.donut').length) {
          donutChart($('.donut:not(.chart-drawn)'));
        }
      }
    });
  });
